import { ReactNode, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { topLevelNonIframe } from ':fat/helpers/iframe';
import { MainPage } from ':fat/messaging/entities/mainPage';
import { initializeMessageBus } from ':fat/messaging/MessageBus';
import { AppRoutes } from ':fat/routing/routes';
import { initializeWorkers } from ':fat/workers/initialization';

type EnsureMessagingAndWorkersAreSetupProps = {
  children: ReactNode;
};

export function EnsureMessagingAndWorkersAreSetup({
  children,
}: EnsureMessagingAndWorkersAreSetupProps) {
  useEnsureOnMainPage();

  const [ready, setReady] = useState(false);
  const navigate = useNavigate();

  const handlerContext: MainPage.HandlerContext = useMemo(
    () => ({
      navigate,
    }),
    [navigate],
  );

  useEffect(() => {
    initializeMessageBus('mainPage', handlerContext);
    initializeWorkers()
      .then(() => {
        setReady(true);
      })
      .catch((error) => {
        // eslint-disable-next-line no-console
        console.error('Worker initialization failed:');
        // eslint-disable-next-line no-console
        console.error(error);
      });

    return () => MessageBus.stopListening();
  }, [handlerContext]);

  if (!ready) return null;

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}

function useEnsureOnMainPage() {
  useEffect(() => {
    if (!topLevelNonIframe()) {
      // eslint-disable-next-line no-console
      console.error('Main Page loaded improperly. Breaking out of iframe');
      if (window.top) {
        window.top.location.href = window.origin + AppRoutes.SECURITY_FRAME_LOADER;
      }
    }
  }, []);
}
